import HomeIcon from '@mui/icons-material/Home';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { MenuItems } from './interfaces';

const menuItemsOperatorFiscal: MenuItems[] = [
    {
        heading: '',
        items: [
            {
                name: 'Home',
                icon: HomeIcon,
                link: '/supervisor/dashboard'
            },
            {
                name: 'Events',
                icon: EventAvailableIcon,
                link: '/supervisor/events'
            },
            {
                name: 'Reports',
                icon: AssessmentIcon,
                link: '/supervisor/reports'
            },
            {
                name: 'Assignments',
                icon: AssignmentIndIcon,
                link: '/supervisor/assignments'
            },
            {
                name: 'Notifications',
                icon: NotificationsActiveIcon,
                link: '/supervisor/notifications'
            },

        ]
    }
];

export default menuItemsOperatorFiscal;
